export default {
  "grid": "_grid_sczq0_1"
};import "/tmp/202335-27-s2e325.g1wec.css";